export default {"src":"/_next/static/media/friends-celebration.colour.31b35563.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};